import {Box, Text} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import type React from 'react';
import {useState} from 'react';
import {MdControlPoint} from 'react-icons/md';
import {atom, useRecoilState} from 'recoil';
import type {Company} from '../../../core/repositories/companyRepository';
import {ScoutPopup} from '../../../features/company/components/Container/Presenter/ScoutPopupModal';
import {useHandleFollowCompany} from '../../../features/company/usecase/useHandleFollowCompany';
import {useMediaQuery} from '../../services/useMediaQuery';
import {NoLoginAlertModal} from '../NoLoginAlertModal';

type BtnSizeProps = {
  size: 'small' | 'medium' | 'large' | 'archive';
  isPc: boolean;
};

type Props = {
  company: Company;
  size?: BtnSizeProps['size'];
};

export const scoutPopupShowDateState = atom({
  key: 'scoutPopupShowDateState',
  default: '',
});

export const FollowCompanyTypeB: React.FC<Props> = ({
  company,
  size = 'medium',
}) => {
  const {isPC} = useMediaQuery();
  const btnSize = ({size, isPc}: BtnSizeProps) => {
    if (isPc) {
      if (size === 'archive' || size === 'medium') {
        return 'h-[20px] w-[55px] mt-[10px] mr-[10px]';
      }

      if (size === 'small') {
        return 'h-[20px] w-[55px]';
      }

      return 'h-[35px] w-[70px] mt-[10px] mr-[10px]';
    }

    if (size === 'archive' || size === 'small') {
      return 'h-[35px] w-[55px]';
    }

    return 'h-[35px] w-[65px]';
  };

  const textSize = ({size, isPc}: BtnSizeProps) => {
    if (isPc) {
      if (size === 'archive' || size === 'medium') {
        return 'text-sm';
      }

      if (size === 'small') {
        return 'text-sm';
      }

      return 'text-base';
    }

    if (size === 'archive' || size === 'small') {
      return 'text-xs';
    }

    return 'text-xs';
  };

  const [checked, setChecked] = useState(false);
  const [scoutPopup, setScoutPopup] = useState(false);

  const [scoutPopupShowDate, setScoutPopupShowDate] = useRecoilState(
    scoutPopupShowDateState,
  );

  const closePopup = () => {
    if (checked) {
      const now = new Date();
      setScoutPopupShowDate(now.toString());
    }

    setScoutPopup(false);
  };

  const [isLoginOpened, {open, close}] = useDisclosure(false);
  const {handleFollowCompany, followCountUpdated, isFollowed} =
    useHandleFollowCompany({
      companyId: company.id,
      followCount: company.followerCount,
      followed: company.isFollowed,
      open,
      setScoutPopup,
      scoutPopupShowDate,
    });
  return (
    <>
      <Box
        className={`flex rounded cursor-pointer pt-[2px] items-center justify-center ${btnSize(
          {
            size,
            isPc: isPC,
          },
        )} ${
          isFollowed
            ? 'bg-success-1 text-white'
            : 'bg-white text-success-1 border-success-1 border'
        }`}
        onClick={async (e) => {
          e.stopPropagation();
          try {
            await handleFollowCompany();
          } catch (error) {
            console.error(error);
          }
        }}
      >
        <MdControlPoint />
        <Text className={`pl-[3px] ${textSize({size, isPc: isPC})}`}>
          {followCountUpdated}
        </Text>
      </Box>
      <NoLoginAlertModal opened={isLoginOpened} onClose={close} />
      <ScoutPopup
        scoutPopup={scoutPopup}
        closePopup={closePopup}
        checked={checked}
        setChecked={setChecked}
      />
    </>
  );
};
